import { Heading4 } from "@/components/text/Heading4";
import { NormalText } from "@/components/text/NormalText";
import { SamplePreview } from "@/components/tutorial/tutorialSteps/SamplePreview";
import { tutorialSamples } from "@/components/tutorial/tutorialSteps/tutorialSamples";

export function InputStep() {
  return (
    <div>
      <Heading4 elementType="h3" className="mb-2">
        Audio Input
      </Heading4>
      <NormalText elementType="p" className="text-sm">
        This is where you upload or record vocals without any instrumentation or
        effects. To demonstrate, <b>select a sample</b> below.
      </NormalText>
      <div
        className="mt-4 flex max-h-96 flex-col gap-y-4 overflow-y-auto p-2"
        data-tutorial-input={true}
      >
        {tutorialSamples.map((tutorialSample) => (
          <SamplePreview
            key={tutorialSample.inputFile}
            tutorialSample={tutorialSample}
          />
        ))}
      </div>
    </div>
  );
}
